import React from 'react';
import { motion } from 'framer-motion';
import content from '../config/content.json';

function Rules() {
  return (
    <div className="rules-page">
      <section className="page-header">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Resident Rules & Regulations
          </motion.h1>
          <p>Please read and follow these guidelines for a harmonious living experience</p>
        </div>
      </section>

      <section className="rules-content">
        <div className="container">
          <div className="rules-grid">
            {content.rules.map((rule, index) => (
              <motion.div 
                key={rule.id}
                className="rule-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
              >
                <div className="rule-number">{rule.id.toUpperCase()}</div>
                <h3>{rule.title}</h3>
                <p>{rule.description}</p>
              </motion.div>
            ))}
          </div>

          <motion.div 
            className="rules-note"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
          >
            <h3>📢 Important Notice</h3>
            <p>These rules are designed to ensure a safe, clean, and respectful environment for all residents. Compliance with these regulations is mandatory for continued stay at Thendral Mansion.</p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Rules;
